<template>
  <el-dialog
    :title="$t('deleteProduct.confirmOperation') + '!'"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div align="center">
      <span>{{ $t('deleteProduct.confirmDeleteProduct') }}</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDeleteProductModel">{{ $t('deleteProduct.cancel') }}</el-button>
      <el-button type="primary" @click="deleteProduct">{{ $t('deleteProduct.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteProduct } from '@/api/admin/deleteProductApi'

export default {
  name: 'DeleteProduct',
  data() {
    return {
      dialogVisible: false,
      deleteProductInfo: {}
    }
  },
  methods: {
    open(product) {
      this.deleteProductInfo = product
      this.dialogVisible = true
    },
    handleClose(done) {
      this.closeDeleteProductModel()
      done()
    },
    async deleteProduct() {
      try {
        const res = await deleteProduct(this.deleteProductInfo)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.$emit('product-deleted')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除商品失败:', error)
        this.$message.error('删除商品失败')
      }
    },
    closeDeleteProductModel() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
</style>